export const ONBOARDING_AGENT_AI_GRADIENT_COLORS = {
    defaultStart: "#3e74fe",
    defaultEnd: "#2ad3ab",
    hoverStart: "#5c8ee6",
    hoverEnd: "#3cc7a5",
    activeStart: "#4b75bf",
    activeEnd: "#31a588",
    triggerStart: "#6da3fe",
    triggerEnd: "#4be1be",
} as const;
